import { render, staticRenderFns } from "./b-ticket.vue?vue&type=template&id=20f128ee&scoped=true"
import script from "./b-ticket.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket.vue?vue&type=style&index=0&id=20f128ee&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f128ee",
  null
  
)

export default component.exports